const NoDataPanel = ({ panel, title }) => {
    return (
        <div id={panel ? `panel_nodata-${panel.id}-${panel.chart_type}` : 'panel_nodata'} className='panel-placeholder'>
            <h2>{title || 'No hay datos para los filtros seleccionados'}</h2>
            {panel?.name ? <h3>{panel.name}</h3> : null}
        </div>
    )
}

export default NoDataPanel;
